import { AutoMap } from 'src_common/common/mobx-utils/AutoMap';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';
import { Resource } from 'src_common/common/mobx-utils/Resource';
import { Common } from 'src/domains/common/Common';

export type GeniusGameTrackerAvailabilityType = 'loading' | 'available' | 'unavailable';

type StatusQueryType = {
    baseUrl: string;
    productName: string;
    fixtureId: string;
};

const buildCacheKey = (query: StatusQueryType): string => JSON.stringify(query);

const FETCH_TIMEOUT_MS = 15_000;

export class GeniusAvailabilityState {
    public static get = AutoWeakMap.create((common: Common) => new GeniusAvailabilityState(common));

    private readonly byKey: AutoMap<string, Resource<'available' | 'unavailable'>>;

    private constructor(private readonly common: Common) {
        this.byKey = new AutoMap((key: string) => {
            const query = JSON.parse(key) as StatusQueryType;

            return new Resource(async (): Promise<'available' | 'unavailable'> => {
                return await this.common.trpcClient.client.genius.getGameTrackerStatus.query(query);
            }, FETCH_TIMEOUT_MS);
        });
    }

    public getGameTrackerAvailability(
        baseUrl: string,
        productName: string,
        fixtureId: string
    ): GeniusGameTrackerAvailabilityType {
        const resource = this.byKey.get(buildCacheKey({ baseUrl, productName, fixtureId }));
        const result = resource.get();

        if (result.type === 'loading') {
            return 'loading';
        }

        // Fail open: API/network errors still show Game Tracker rather than empty MatchLead
        if (result.type === 'error') {
            return 'available';
        }

        return result.value;
    }
}
